export default defineComponent({
  props: {},
  setup: function setup() {},
  data: function data() {
    return {
      step: 1
    };
  },
  computed: {}
});